module.exports = __webpack_public_path__ + "static/media/ab.a1d03c89.png";